<template>
  <div>
    <!-- Filters -->
    <stores-list-filters
      :store-filter.sync="storeStatusFilter"
      :stores-options="storesOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Affichage</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Magasins</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                variant="primary"
                @click="$router.push({ name: 'apps-store-add' })"
              >
                <span class="text-nowrap">Ajouter Magasin</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refStockStoresListTable"
        class="position-relative"
        :items="fetchStoresList"
        responsive
        :fields="tableColumns"
        primary-key="uid"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Pas de magasin trouvé"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- A virtual column -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <!-- Column: Status -->
        <template #cell(is_active)="data">
          <b-badge
            :variant="data.item.is_active ? 'primary' : 'danger'"
            class="text-capitalize"
          >
            {{ data.item.is_active ? "Actif" : "Inactif" }}
          </b-badge>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div v-if="!data.item.deleted_at" class="text-nowrap text-center">
            <feather-icon
                :id="`store-row-${data.item.uid}-edit-icon`"
                icon="ClipboardIcon"
                class="cursor-pointer text-warning"
                size="16"
                @click="$router.push({ name: 'apps-stock-store-details', params: { id: data.item.uid }})"
            />
            <b-tooltip
                title="Voir Magasin"
                class="cursor-pointer"
                :target="`store-row-${data.item.uid}-edit-icon`"
            />
          </div>
          <b-badge
              v-else
              pill
              :variant="`light-danger`"
              class="text-capitalize"
          >
            <feather-icon icon="XIcon" />
          </b-badge>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} magasins</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalStores"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BTooltip,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import StockStoresListFilters from "./StockStoresListFilters.vue";
import useStockStoresList from "./useStockStoresList";

export default {
  name: "StoresList",
  components: {
    StoresListFilters: StockStoresListFilters,

    BTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const {
      fetchStoresList,
      tableColumns,
      perPage,
      currentPage,
      totalStores,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refStockStoresListTable,
      refetchData,
      toggleStore,
      deleteStore,

      // Extra Filters
      storeStatusFilter,
      storesOptions,
    } = useStockStoresList();

    return {
      fetchStoresList,
      tableColumns,
      perPage,
      currentPage,
      totalStores,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refStockStoresListTable,
      refetchData,
      toggleStore,
      deleteStore,

      storeStatusFilter,
      storesOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
